import { render, staticRenderFns } from "./modificationDiff.vue?vue&type=template&id=0d8a8454&scoped=true"
import script from "./modificationDiff.vue?vue&type=script&lang=js"
export * from "./modificationDiff.vue?vue&type=script&lang=js"
import style0 from "./modificationDiff.vue?vue&type=style&index=0&id=0d8a8454&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a8454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8a8454')) {
      api.createRecord('0d8a8454', component.options)
    } else {
      api.reload('0d8a8454', component.options)
    }
    module.hot.accept("./modificationDiff.vue?vue&type=template&id=0d8a8454&scoped=true", function () {
      api.rerender('0d8a8454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/modificationDiff.vue"
export default component.exports